import React, { useState, useContext, useEffect } from "react";
import Textinput from "../elements/TextInput/TextInput";
import Button from "../elements/Button/Button";
import JobDashCss from "./JobDashboard.css";
import { useNavigate } from "react-router-dom";
import { useCommonContext } from "../../context/CommonContext";
// import starSVG from '../../assets/AI.svg'
const JobDashboard = () => {
  const { jobCreationData, setJobCreationData, sanitizeInput } =
    useCommonContext();
  const navigate = useNavigate();
  const [JobTitle, SetJobTitle] = useState("");
  const [warningmsg, setWarningmsg] = useState("");

  const starSvgIcon = (
    <svg
      width="24"
      height="24"
      className="pr-2"
      viewBox="0 0 501 501"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M207.45 95.3839C211.515 97.4703 213.187 98.8017 215.089 103.015C215.537 104.505 215.96 106.002 216.364 107.505C216.605 108.331 216.846 109.157 217.095 110.008C217.902 112.794 218.676 115.588 219.45 118.384C220.031 120.43 220.614 122.476 221.199 124.521C223.411 132.292 225.613 140.066 227.767 147.853C231.664 161.911 235.965 175.295 242.45 188.384C242.906 189.311 242.906 189.311 243.372 190.256C249.434 202.478 257.201 213.316 266.497 223.278C268.09 224.997 269.564 226.733 271.012 228.571C292.997 253.938 326.879 265.825 358.075 274.571C360.508 275.262 362.94 275.954 365.372 276.648C366.556 276.985 367.741 277.323 368.962 277.67C373.466 278.956 377.97 280.247 382.472 281.539C385.159 282.301 387.851 283.04 390.547 283.773C391.981 284.18 393.415 284.588 394.848 284.997C396.028 285.321 397.208 285.645 398.424 285.979C402.401 287.825 403.914 289.83 406.45 293.384C407.114 295.509 407.114 295.509 407.075 297.384C407.088 298.003 407.101 298.621 407.114 299.259C405.889 303.178 403.309 306.408 399.679 308.314C397.56 309.081 395.44 309.708 393.266 310.298C392.445 310.539 391.623 310.781 390.777 311.029C388.007 311.836 385.229 312.611 382.45 313.384C380.405 313.966 378.361 314.549 376.317 315.133C368.544 317.345 360.769 319.547 352.981 321.701C338.923 325.598 325.539 329.899 312.45 336.384C311.832 336.688 311.215 336.992 310.578 337.306C281.497 351.727 258.698 375.437 243.575 403.946C243.147 404.747 242.719 405.548 242.278 406.374C235.862 418.877 231.87 432.036 228.102 445.517C227.911 446.199 227.721 446.882 227.524 447.585C225.729 454.017 223.949 460.453 222.188 466.894C221.215 470.45 220.227 474.001 219.23 477.55C218.857 478.889 218.49 480.229 218.129 481.571C214.632 494.557 214.632 494.557 209.45 499.384C206.269 500.974 202.867 501.173 199.45 500.384C193.975 496.645 192.247 493.5 190.536 487.2C190.295 486.379 190.053 485.557 189.805 484.711C188.998 481.941 188.223 479.163 187.45 476.384C186.868 474.339 186.285 472.295 185.701 470.251C183.489 462.478 181.287 454.703 179.132 446.915C175.235 432.857 170.935 419.473 164.45 406.384C164.145 405.766 163.841 405.148 163.527 404.512C157.466 392.289 149.699 381.452 140.403 371.489C138.809 369.771 137.335 368.035 135.887 366.196C120.277 348.184 96.0968 335.094 73.7624 327.677C73.0062 327.425 72.2501 327.174 71.471 326.915C64.2557 324.564 56.9627 322.509 49.653 320.474C47.8332 319.966 47.8332 319.966 45.9767 319.449C40.9335 318.046 35.8898 316.645 30.8395 315.267C27.1067 314.246 23.3796 313.205 19.653 312.161C18.5155 311.856 17.378 311.551 16.206 311.236C10.1454 309.522 5.85453 307.959 1.44987 303.384C-0.140485 300.203 -0.339508 296.801 0.449866 293.384C4.1891 287.909 7.33341 286.181 13.6335 284.47C14.455 284.229 15.2764 283.987 16.1228 283.739C18.8927 282.932 21.6704 282.157 24.4499 281.384C26.4946 280.802 28.5391 280.219 30.5832 279.635C38.3554 277.423 46.1306 275.221 53.9189 273.067C67.9767 269.169 81.3605 264.869 94.4499 258.384C95.3766 257.927 95.3766 257.927 96.3221 257.462C108.545 251.399 119.398 243.632 129.352 234.325C131.45 232.384 131.45 232.384 134.512 230.009C139.068 225.938 142.693 221.186 146.45 216.384C147.587 214.953 147.587 214.953 148.747 213.493C159.377 199.784 167.685 184.172 173.157 167.7C173.408 166.944 173.66 166.188 173.919 165.41C176.274 158.182 178.326 150.875 180.36 143.552C180.867 141.729 180.867 141.729 181.385 139.868C182.789 134.814 184.191 129.76 185.566 124.698C186.587 120.958 187.628 117.223 188.673 113.489C188.978 112.347 189.283 111.204 189.598 110.027C191.261 104.147 192.499 100.126 197.45 96.3839C200.616 94.8007 204.024 94.7402 207.45 95.3839Z"
        fill="white"
      />
      <path
        d="M408.798 0.179753C410.675 1.15652 411.447 1.77987 412.325 3.75219C412.532 4.44983 412.728 5.15098 412.914 5.85451C413.026 6.24122 413.137 6.62793 413.252 7.02636C413.625 8.33071 413.982 9.63886 414.339 10.9477C414.608 11.9057 414.877 12.8634 415.147 13.821C416.169 17.459 417.185 21.0986 418.18 24.7443C419.98 31.3258 421.966 37.5917 424.96 43.7197C425.171 44.1536 425.171 44.1536 425.386 44.5963C428.185 50.3184 431.772 55.3924 436.065 60.0564C436.801 60.8607 437.481 61.6735 438.15 62.5344C448.302 74.4102 463.949 79.9752 478.354 84.0703C479.478 84.3937 480.601 84.7177 481.724 85.0423C482.271 85.2003 482.818 85.3583 483.382 85.5211C485.462 86.123 487.541 86.7274 489.621 87.3322C490.862 87.6893 492.105 88.0353 493.349 88.3783C494.012 88.5689 494.674 88.7599 495.336 88.9514C495.881 89.103 496.426 89.2547 496.987 89.411C498.823 90.2754 499.522 91.2139 500.693 92.8778C501 93.8727 501 93.8727 500.982 94.7505C500.988 95.0402 500.994 95.3298 501 95.6283C500.434 97.463 499.243 98.9751 497.566 99.8678C496.588 100.227 495.609 100.52 494.605 100.796C494.226 100.909 493.847 101.022 493.456 101.139C492.177 101.517 490.894 101.879 489.61 102.241C488.666 102.514 487.722 102.787 486.778 103.06C483.189 104.096 479.599 105.126 476.002 106.135C469.51 107.96 463.33 109.973 457.285 113.009C457 113.152 456.715 113.294 456.421 113.441C442.992 120.192 432.463 131.293 425.48 144.64C425.282 145.015 425.085 145.39 424.881 145.776C421.918 151.63 420.075 157.791 418.335 164.102C418.247 164.422 418.158 164.741 418.068 165.07C417.239 168.082 416.417 171.095 415.604 174.11C415.154 175.775 414.698 177.438 414.238 179.099C414.065 179.726 413.896 180.354 413.729 180.982C412.114 187.061 412.114 187.061 409.721 189.321C408.252 190.066 406.681 190.159 405.103 189.789C402.575 188.039 401.777 186.567 400.987 183.617C400.876 183.233 400.764 182.848 400.649 182.452C400.277 181.155 399.919 179.855 399.562 178.553C399.293 177.596 399.024 176.639 398.754 175.682C397.733 172.043 396.716 168.403 395.721 164.757C393.921 158.175 391.935 151.909 388.941 145.781C388.8 145.492 388.66 145.203 388.515 144.905C385.716 139.183 382.129 134.109 377.836 129.445C377.1 128.64 376.42 127.827 375.751 126.967C368.542 118.534 357.376 112.405 347.063 108.933C346.713 108.815 346.364 108.697 346.004 108.576C342.672 107.475 339.305 106.513 335.929 105.561C335.089 105.323 335.089 105.323 334.231 105.081C331.903 104.424 329.573 103.768 327.241 103.123C325.518 102.645 323.796 102.158 322.075 101.669C321.55 101.526 321.025 101.383 320.484 101.236C317.685 100.433 315.704 99.7016 313.67 97.5595C312.935 96.0704 312.843 94.4774 313.208 92.8778C314.934 90.3146 316.386 89.5055 319.296 88.7045C319.675 88.5915 320.054 88.4786 320.445 88.3622C321.724 87.9845 323.007 87.6217 324.291 87.2597C325.235 86.9873 326.179 86.7144 327.123 86.4409C330.712 85.4054 334.303 84.3745 337.899 83.3658C344.391 81.5412 350.571 79.5278 356.616 76.4918C357.044 76.278 357.044 76.278 357.48 76.06C363.125 73.2218 368.136 69.5855 372.733 65.2282C373.702 64.3193 373.702 64.3193 375.116 63.2074C377.22 61.3016 378.894 59.0767 380.629 56.8286C381.154 56.1587 381.154 56.1587 381.689 55.4753C386.598 49.0569 390.435 41.748 392.962 34.0363C393.078 33.6824 393.194 33.3285 393.314 32.9638C394.401 29.58 395.349 26.1593 396.288 22.7306C396.522 21.877 396.522 21.877 396.761 21.0061C397.409 18.6399 398.057 16.2736 398.692 13.9038C399.163 12.1526 399.644 10.4043 400.127 8.65623C400.268 8.12126 400.409 7.5863 400.554 7.03513C401.322 4.28233 401.894 2.39996 404.18 0.647925C405.642 -0.0933073 407.216 -0.121629 408.798 0.179753Z"
        fill="white"
      />
    </svg>

    // <svg className="w-4 h-5 text-teal-300 mr-2"
    //     fill="none"
    //     stroke="white"
    //     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">

    //     <path strokeLinecap="round"
    //     strokeLinejoin="round"
    //     strokeWidth="2"
    //     d="M11 6.999c2.395.731 4.27 2.607 4.999 5.001.733-2.395 2.608-4.269 5.001-5-2.393-.731-4.268-2.605-5.001-5-.729 2.394-2.604 4.268-4.999 4.999zm7 7c1.437.438 2.562 1.564 2.999 3.001.44-1.437 1.565-2.562 3.001-3-1.436-.439-2.561-1.563-3.001-3-.437 1.436-1.562 2.561-2.999 2.999zm-6 5.501c1.198.365 2.135 1.303 2.499 2.5.366-1.198 1.304-2.135 2.501-2.5-1.197-.366-2.134-1.302-2.501-2.5-.364 1.197-1.301 2.134-2.499 2.5zm-6.001-12.5c-.875 2.873-3.128 5.125-5.999 6.001 2.876.88 5.124 3.128 6.004 6.004.875-2.874 3.128-5.124 5.996-6.004-2.868-.874-5.121-3.127-6.001-6.001z"/>

    // </svg>
  );
  const valueChange = (value) => {
    const sanitizedValue = sanitizeInput(value);
    SetJobTitle(sanitizedValue);
    setWarningmsg("");
    setJobCreationData((prev) => ({
      ...prev,
      jobTitle: sanitizedValue,
      description: "",
    }));
  };
  const randomJobId = Math.floor(1000 + Math.random() * 9000);
  // const mannualJobPost = () =>{
  //     setJobCreationData((prevData) => ({
  //         ...prevData,
  //         jobid: randomJobId.toString(),
  //     }));
  //     localStorage.setItem("jobCreationData", JSON.stringify(jobCreationData));
  //     if(JobTitle === ""){
  //         setWarningmsg("Please enter Job Title to proceed");
  //     } else {
  //         navigate("/NewJobPost");
  //     }
  // }
  useEffect(() => {
    if (jobCreationData) {
      localStorage.setItem("jobCreationData", JSON.stringify(jobCreationData));
    }
  }, [jobCreationData]);
  const mannualJobPost = () => {
    if (JobTitle === "") {
      setWarningmsg("Please enter Job Title to proceed");
      return;
    }

    setJobCreationData((prevData) => ({
      company_id: "",
      company: "",
      workplaceType: "",
      jobLocation: "",
      jobType: "",
      description: "",
      selectedSkills: [],
      collaborators: [],
      team: [{ name: "", designation: "", url: "" }],
      questions: [],
      slots: {},
      schedule_config_days: "",
      override: {},
      interviewers: [],
      interview_location: "",
      interview_duration: "",
      timezone: "",
      jobid: randomJobId.toString(),
      jobTitle: JobTitle,
    }));

    setTimeout(() => {
      navigate("/NewJobPost");
    }, 0);
  };

  const aiJobPost = () => {
    if (JobTitle === "") {
      setWarningmsg("Please enter Job Title to proceed");
      return;
    }

    setJobCreationData((prevData) => ({
      company_id: "",
      company: "",
      workplaceType: "",
      jobLocation: "",
      jobType: "",
      description: "",
      selectedSkills: [],
      collaborators: [],
      team: [{ name: "", designation: "", url: "" }],
      questions: [],
      slots: {},
      schedule_config_days: "",
      override: {},
      interviewers: [],
      interview_location: "",
      interview_duration: "",
      timezone: "",
      jobid: randomJobId.toString(),
      jobTitle: JobTitle,
    }));
    localStorage.removeItem("jobCreationData");

    setTimeout(() => {
      navigate("/JobCreation");
    }, 0);
  };
  // const aiJobPost = () =>{
  //     setJobCreationData((prevData) => ({
  //         ...prevData,
  //         jobid: randomJobId.toString(),
  //     }));
  //     localStorage.setItem("jobCreationData", JSON.stringify(jobCreationData));
  //     if(JobTitle === ""){
  //         setWarningmsg("Please enter Job Title to proceed");
  //     } else {
  //         navigate("/JobCreation");
  //     }
  // }

  return (
    <div className="w-full">
      <div
        className="flex items-center px-4 sm:px-6 lg:px-8 mx-2 sm:mx-4 rounded-2xl py-8 sm:py-12 font-family"
        style={{ backgroundColor: "rgba(255, 255, 255, 0.6)" }}
      >
        <div className="w-full max-w-4xl mx-auto">
          <h3 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-center leading-tight sm:leading-[60px] md:leading-[70px] lg:leading-[80px] font-semibold mb-4">
            Open Doors to Talent
          </h3>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-600 text-center mb-6">
            Craft a role description that invites the best to join your team.
          </p>
          <div className="w-full max-w-2xl mx-auto mb-6">
            <p className="text-md text-black mb-2">
              Job Title <span style={{ color: "red" }}>*</span>
            </p>
            <Textinput
              value={JobTitle}
              onChange={(e) => valueChange(e.target.value)}
              placeholder="Add your title"
              labelclass="hidden"
              className="w-full border-2 focus:border-none border-gray-300 focus:ring-4 focus:ring-green-700 focus:outline-none py-3 focus:shadow-[0_0_20px_4px_rgba(0,255,0,0.5)] border-radient-green"
            />
            {warningmsg && <span style={{ color: "red" }}>{warningmsg}</span>}
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-5">
            <Button
              style={{ borderRadius: "10px" }}
              PreSvgIcon={starSvgIcon}
              children={` Write with AI`}
              className="text-white px-4 py-2 flex justify-center items-center w-full sm:w-auto"
              onClick={aiJobPost}
            />
            <Button
              style={{ borderRadius: "10px" }}
              children="Write On My Own"
              className="text-white px-4 py-2 w-full sm:w-auto"
              onClick={mannualJobPost}
            />
          </div>
          <div className="mt-6 w-full max-w-2xl mx-auto hidden">
            <p className="text-sm text-gray-600 text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolor
            </p>
            <p className="text-sm text-gray-600 text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolor
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobDashboard;
